<!-- 音像 -->

<template>
  <div class="ssTabList2">
    <div class="tabArea">
      <div v-if="role == 'press'" class="headBar">
        <span>出版连续型电子出版物单位提交</span>
        <i class="el-icon-arrow-right"></i>
        <span>{{ bookName }}</span>
      </div>
      <div v-else class="headBar">
        <span>{{ bookName }}</span>

        <a :href="fileUrl" class="downBtn" download>
          <el-button style="float: none" size="mini">下载封面和盖章页</el-button>
        </a>

        <!-- <el-select v-model="selYear" @change="valChange" size="medium" placeholder="历年记录" style="float:right;">
                        <el-option
                            v-for="item in selYears"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            >
                        </el-option>
                    </el-select> -->
      </div>

      <table class="tabElement">
        <tr class="tabHead">
          <td>序号</td>
          <td>连续型电子出版物出版情况登记表</td>

          <td>查阅时间</td>
          <td colspan="2">操作</td>
        </tr>
        <tr v-for="(term, inx) in tabDat" :key="inx">
          <td>{{ inx + 1 }}</td>
          <td>{{ term.name }}</td>
          <td>{{ term.updatedAt | translate("time") }}</td>
          <td>
            <span v-if="term.code != 501">
              <el-button @click="toEdit(term)" size="mini">查看</el-button>
            </span>
            <span v-if="term.code == 501">
              <el-button size="mini" type="warning" v-if="term.status == 2">
                <a @click="filesDown(term)" download>下载</a>
              </el-button>
              <el-button size="mini" disabled v-if="term.status != 2"> 未上传 </el-button>
            </span>
          </td>
          <td v-if="inx == 0">
            <a href="javascript:void(0);" v-if="term.code == '402'">
              <el-button size="mini" @click="dmyfile(1, term)">导出打印表</el-button>
            </a>
            <a href="javascript:void(0);" v-else-if="term.code == '404'">
              <el-button size="mini" @click="dmyfile(1, term)">导出打印表</el-button>
            </a>
          </td>
          <td v-else-if="inx == 1">
            <a href="javascript:void(0);" v-if="term.code == '401'">
              <el-button size="mini" @click="dmyfile(2, term)">导出打印表</el-button>
            </a>
            <a href="javascript:void(0);" v-else-if="term.code == '404'">
              <el-button size="mini" @click="dmyfile(2, term)">导出打印表</el-button>
            </a>
          </td>
          <td v-else-if="inx == 2" rowspan="3">&nbsp;</td>
          <td v-else-if="inx == 5">&nbsp;</td>
        </tr>
      </table>

      <div v-if="role == 'press'" class="subArea">
        <el-button @click="goBack">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getSuccessTabs } from "@/api/pressRole/pressSuccessive";
import { expFile } from "@/api/export";
import { filesDownload, filesDownloadUploadBtn } from "@/api/file";
export default {
  props: ["bookName", "pressDat", "role", "selYears", "defaultYear"],
  data() {
    return {
      querys: {},
      tabDat: [],
      tabDat1: [],
      postId: "",
      selYear: "",
      zeroStoreage: {
        id: "",
        publishMaterialId: "",
        publishId: "",
        fileId: "",

        wSat: 0,
      },
      opMsg: "",

      printUrl: "",
      fileUrl: "",
    };
  },
  filters: {
    translate: function (dat, code) {
      if (code == "pgress") {
        if (dat == 8) {
          return "未提交";
        } else if (dat == 2) {
          return "已提交";
        }
      } else if (code == "time") {
        return dat.substr(0, 16);
      }
    },
  },
  methods: {
    // zym.文件下载
    filesDown: function (dat) {
      if (dat.status == 1) {
        this.$message({
          message: "附件未上传",
          type: "error",
        });
      } else {
        // console.log("dat:", JSON.stringify(dat));
        if (dat.id && (dat.materialCode || dat.code)) {
          var dataIn = {};
          dataIn.organizationMaterialId = dat.id;
          // 兼容连续型出版物
          dataIn.code = dat.materialCode || dat.code;
          dataIn.materialTitle = dat.materialTitle || dat.name;
          dataIn.organizationId = dat.organizationId;
          // console.log(JSON.stringify(dat));
          filesDownloadUploadBtn(dataIn).then((response) => {
            window.open(response.payload.url);
          });
        }
      }
    },
    valChange: function () {
      this.$emit("valChangeSearch", this.selYear);
    },
    toEdit: function (row) {
      let urlMap = {
        401: "ss_skimtab1",
        402: "ss_skimtab2",
        403: "ss_skimtab3",
        404: "ss_listtab4",

        405: "ss_skimtab5", // pressRole/SuccessivePart/forTabs/ssTab4
      };

      this.$router.push({
        path: urlMap[row.code],
        query: {
          pressId: row.organizationId,
          mtId: row.id,
          pgress: 2,
          role: this.role,
          listId: this.$route.query.listId,
          bookName: this.querys.bookName,
          pgsType: this.$route.pgsType,
        },
      });
    },

    zeroStoreCtrls: function (dat) {
      let detAble = this.zeroStoreage.fileId;
      this.zeroStoreage.fileId = dat;
      sUpdate0({
        pfile1: this.zeroStoreage,
      })
        .then((response) => {
          if (detAble) {
            detFile({
              id: detAble,
            }).then((inresp) => {
              this.zeroStoreage.id = response.pfile1.id;
            });
          }
        })
        .catch((error) => {});
    },

    arraySpanMethod: function ({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == 0 && columnIndex == 4) {
        return [3, 1];
      }
    },

    pressInit: function () {
      let vm = this;
      let unFormate = this.pressDat[0];
      this.postId = this.pressDat[0][0].publishMaterialId;
      this.querys = {
        listId: this.$route.query.listId,
        pressId: this.$route.query.pressId,
        bookName: this.$route.query.bookName,
      };

      for (let i = 0; i < unFormate.length; i++) {
        if (i < 3) {
          this.tabDat.push(unFormate[i]);
        } else {
          this.tabDat.push(unFormate[i]);
        }
      }

      vm.printUrl =
        process.env.BASE_API +
        "/File/File/printLxJbxx?type=" +
        vm.pressType +
        "&publishMaterialId=" +
        vm.querys.listId +
        "&token=" +
        encodeURIComponent(vm.$store.getters.token);
      vm.printUrl1 =
        process.env.BASE_API +
        "/File/File/printRyJbxx?type=3&publishMaterialId=" +
        vm.tabDat[3].id +
        "&token=" +
        encodeURIComponent(vm.$store.getters.token);
    },

    goBack: function () {
      this.$router.go(-1);
    },

    postPrevs: function () {
      return this.postId;
    },
    dmyfile: function (exp, term) {
      var params = {};
      var expUrl = "";
      if (exp == 1) {
        expUrl = "/api/export/printLxJbxx";
        params = {
          firstYear: this.$route.query.firstYear,
          type: this.pressType,
          publishMaterialId: this.querys.listId,
        };
      } else if (exp == 2) {
        expUrl = "/api/export/printRyJbxx";
        params = {
          type: 3,
          publishMaterialId: term.id,
        };
      }
      expFile({
        expUrl: expUrl,
        p: params,
      })
        .then((blob) => {
          let blobHref = window.URL.createObjectURL(blob);
          let anchor = document.createElement("a");
          anchor.href = blobHref;
          var fname = localStorage.getItem("dfilename");
          anchor.download = decodeURIComponent(fname);
          document.body.appendChild(anchor);
          anchor.click();
          window.URL.revokeObjectURL(blobHref);
          document.body.removeChild(anchor);
        })
        .catch((error) => {});
    },
  },
  created: function () {
    this.pressInit();
    // this.fileUrl = process.env.BASE_API + '/File/File/downloadDrmb?code=002&token=' + encodeURIComponent(this.token);
    this.filrUrl = process.env.URL_FILE + "/drmb/002.xlsx"; // 封面和盖章页
  },

  mounted: function () {
    this.selYear = this.defaultYear;
  },
};
</script>

<style lang="scss" type="text/css">
.ssTabList2 {
  // padding:9px;
  font-size: 14px;
  letter-spacing: 0.72px;

  .userTab {
    margin-top: 42px;
  }

  .pressTtl {
    display: inline-block;
  }

  .rejects {
    border: 1px solid red;
    color: red;
    padding: 15px 0px;
    border-radius: 3px;

    .rejLine {
      position: relative;
      line-height: 20px;

      .rejName {
        width: 70px;
        text-align: right;
        float: left;
      }

      .rejText {
        margin-left: 65px;
      }
    }
  }

  .headBar {
    padding: 0px 24px;
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    color: #666666;
    margin-top: 9px;

    .el-button {
      float: right;
      margin-top: 9px;

      span {
        font-size: 12px;
      }
    }
  }

  .tabArea {
    margin-top: 12px;
    // padding-bottom: 24px;

    .headBar {
      margin-bottom: 9px;
    }
  }

  .tabTips {
    font-size: 12px;
    color: #999999;
    margin-top: 9px;

    .tipLine {
      padding-left: 20px;
      position: relative;

      .fsDot {
        width: 45px;
        position: absolute;
        left: 0px;
      }
    }
  }

  .subBar {
    padding: 0px 24px;
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    margin-top: 6px;
    color: #666666;
  }

  .subArea {
    text-align: center;
    margin-top: 30px;
    margin-bottom: 50px;

    .el-button {
      width: 150px;
    }
  }

  .succedTips {
    font-size: 14px;
    color: #666666;
    padding: 20px;

    a {
      color: #409eff;
    }
  }

  .dvsWait {
    text-align: center;
    line-height: 240px;
    font-size: 24px;
    color: #999999;
  }

  .subArea {
    text-align: center;
  }

  .subArea .el-button {
    width: 180px;
  }

  .tabElement {
    width: 100%;

    .tabHead {
      font-size: 14px;
      font-weight: bold;

      td {
        background: #f5f7fa;
        padding: 15px 20px;
        color: #909399;
      }
    }

    td {
      border-collapse: collapse;
      border: 1px solid #ebeef5;
      text-align: center;
      padding: 12px;
      color: #606266;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ssCommonTabs.vue?5da76cf2